<template>
  <div>
    <div>
      <form-accordion :title="$t('common.security.ssh')" :isTitleUpperCase="false" >
        <b-row class="d-flex justify-content-center align-items-center">
          <b-col sm="6" v-if="isRightPod" class="form-group">
            <div>
              <span class="filter-item-title">{{ $t('common.security.pod_select') }}</span>
              <span class="color-red">* </span>
              <b-form-select v-model="form.pod" :options="podList" style="font-size:small;"></b-form-select>
            </div>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="form.name" isMandatory
              :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>
      <form-accordion :title="$t('common.security.public_key')" :isTitleUpperCase="false">
        <div v-if="this.id != -1">
          <button class="btn w-auto px-4 btn-tertiary mb-5" v-if="form.statePublicKey === 1" @click="updatePublicKey">{{ $t('common.security.cancel_public_key') }}</button>
          <button class="btn w-auto px-4 btn-tertiary mb-5" v-else @click="cancelPublicKey">{{ $t('common.security.update_public_key') }}</button>
        </div>
        <b-row v-if="form.statePublicKey === 1" class="d-flex justify-content-center align-items-center">
          <b-col v-if="publicKeyText === ''" sm="6" class="form-group">
            <span class="filter-item-title">{{ $t('common.security.public_key_file') }}</span>
            <span class="color-red">* </span>
            <b-form-textarea
              style="max-height: none;"
              id="textarea"
              v-model="publicKeyText"
              @input="processPublicKey"
              :placeholder="$t('common.enter_something')"
              rows="6">
            </b-form-textarea>
          </b-col>
          <b-col sm="6" class="form-group d-flex flex-column" v-if="publicKeyText === ''" >
            <span>
              <span class="filter-item-title">{{ $t('common.security.public_key_file') }}</span>
              <span class="color-red">* </span>
            </span>
            <input type="file" @change="handleFileUploadPublicKey"/>
          </b-col>
        </b-row>
        <b-row v-if="publicKeyText !== '' && form.statePublicKey === 1" class="d-flex justify-content-center align-items-center">
          <b-col sm="12" class="form-group">
            <span class="filter-item-title">{{ $t('common.security.public_key_file') }}</span>
            <span class="color-red">* </span>
            <b-form-textarea
              style="max-height: none;"
              id="textarea"
              v-model="publicKeyText"
              @input="processPublicKey"
              :placeholder="$t('common.enter_something')"
              rows="6">
            </b-form-textarea>
          </b-col>
          <b-col sm="6" class="form-group d-flex flex-column" v-if="publicKeyText === ''" >
            <span>
              <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
              <span class="color-red">* </span>
            </span>
            <input type="file" @change="handleFileUploadPublicKey" />
          </b-col>
        </b-row>
      </form-accordion>
      <form-accordion :title="$t('common.security.private_key')" :isTitleUpperCase="false">
        <div v-if="this.id !== -1">
          <button class="btn w-auto px-4 btn-tertiary mb-5" v-if="form.statePrivateKey === 1" @click="updatePrivateKey">{{ $t('common.security.cancel_privatekey') }}</button>
          <button class="btn w-auto px-4 btn-tertiary mb-5" v-else @click="cancelPrivateKey">{{ $t('common.security.update_privatekey') }}</button>
        </div>
        <b-row v-if="form.statePrivateKey === 1" class="d-flex justify-content-center align-items-center">
          <b-col v-if="privateKeyText === '' && form.statePrivateKey === 1" sm="6" class="form-group">
            <span class="filter-item-title">{{ $t('common.security.private_key_file') }}</span>
            <span class="color-red">* </span>
            <b-form-textarea
              style="max-height: none;"
              id="textarea"
              v-model="privateKeyText"
              @input="processPrivateKey"
              :placeholder="$t('common.enter_something')"
              rows="6">
            </b-form-textarea>
          </b-col>
          <b-col v-if="privateKeyText !== '' && form.statePrivateKey === 1" sm="12" class="form-group">
            <span class="filter-item-title">{{ $t('common.security.private_key_file') }}</span>
            <span class="color-red">* </span>
            <b-form-textarea
              style="max-height: none;"
              id="textarea"
              v-model="privateKeyText"
              @input="processPrivateKey"
              :placeholder="$t('common.enter_something')"
              rows="6">
            </b-form-textarea>
          </b-col>
          <b-col sm="6" class="form-group d-flex flex-column" v-if="privateKeyText === '' && form.statePrivateKey === 1" >
            <span>
              <span class="filter-item-title">{{ $t('common.security.private_key_file') }}</span>
              <span class="color-red">* </span>
            </span>
            <input type="file" @change="handleFileUploadPrivateKey" />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="form.password"
              :inputLabel="$t('common.security.password')" :placeholderValue="$t('common.security.password')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group"></b-col>
        </b-row>
      </form-accordion>
    </div>
    <b-row class="mt-3 justify-content-end">
      <b-col cols="4" lg="2" xl="1" v-if="canSaveSSH">
        <b-button variant="primary"
          @click="updateSSH()">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.security.update_ssh') }}</span>
        </b-button>
      </b-col>
      <b-col cols="4" lg="2" xl="1" v-else>
        <b-button variant="primary" disabled>
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.security.update_ssh') }}</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import {errorMessageAlert} from '@/helpers/alert'
import CertificatesList from "@/pages/security/CertificatesList.vue";
import {loadPage} from "@/helpers/routing";
import _ from "lodash";

export default {
  name: 'SSHFormEdit',
  computed: {
    CertificatesList() {
      return CertificatesList
    }
  },
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: ['password', 'pod', 'id', 'name'],
  data () {
    return {
      form: {
        statePrivateKey: 0,
        statePublicKey: 0,
        privateKey: '',
        publicKey: '',
        name: '',
        password: '',
        id: '',
        pod: ''
      },
      publicKeyText: '',
      privateKeyText: '',
      podList: [],
      canSaveSSH: false,
    }
  },
  watch: {
    form: {
      handler() {
        this.checkFormSSH()
      },
      deep: true,
    },
    publicKeyText: {
      handler() {
        this.checkFormSSH()
      },
      deep: true,
    },
    privateKeyText: {
      handler() {
        this.checkFormSSH()
      },
      deep: true,
    },
  },
  created () {
    this.form.id = this.id
    this.form.name = this.name
    this.form.pod = this.pod
    this.form.password = this.password
    let that = this
    this.$engine.firstOn().routing.pod.fetch()
    .then(resp => {
      if (resp.data.Pods.length > 0){
        this.podList.push({text: this.$i18n.t('common.security.select_an_option'), value: ''})
        resp.data.Pods.forEach(element => {
          this.podList.push({text: element.name, value: element.name})
        })
      }

    })
    .catch(error => {
      errorMessageAlert(error, that)
    })
  },
  methods: {
    isRightPod () {
      return this.$engine.firstOn().rights.rightIs('pod_consult', true)
    },
    updatePrivateKey () {
      this.form.statePrivateKey = 0
      this.form = _.cloneDeep(this.form)
    },
    cancelPrivateKey () {
      this.form.statePrivateKey = 1
      this.privateKeyText = ''
      this.form = _.cloneDeep(this.form)
    },
    updatePublicKey () {
      this.form.statePublicKey = 0
      this.form = _.cloneDeep(this.form)
    },
    cancelPublicKey () {
      this.form.statePublicKey = 1
      this.publicKeyText = ''
      this.form = _.cloneDeep(this.form)
    },
    processPublicKey () {
      // try {
      //   // Vérifier si la clé publique est en format OpenSSH (commence par "ssh-rsa")
      //   if (this.publicKeyText.startsWith('---- BEGIN SSH2 PUBLIC KEY ----')) {
      //     this.form.publicKey = this.publicKeyText;  // Simplement afficher ou utiliser la clé telle quelle
      //   } else {
      //     throw new Error('Format de clé publique SSH non valide.');
      //   }
      // } catch (err) {
      //   this.errorMessage = 'Erreur lors du traitement de la clé publique SSH';
      //   console.error(err);
      //   this.publicKeyText = ''
      // }
    },
    processPrivateKey() {
      // try {
      //   // Valider que c'est bien une clé privée SSH en vérifiant le format
      //   if (this.privateKeyText.startsWith('-----BEGIN OPENSSH PRIVATE KEY-----')) {
      //     this.form.privateKey = this.privateKeyText;  // Simplement afficher ou utiliser la clé telle quelle
      //   } else {
      //     throw new Error('Format de clé privée SSH non valide.');
      //   }
      // } catch (err) {
      //   this.errorMessage = 'Erreur lors du traitement de la clé privée SSH';
      //   console.error(err);
      //   this.privateKeyText = ''
      // }
    },
    handleFileUploadPrivateKey(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        this.form.privateKey = e.target.result
        this.privateKeyText = e.target.result
      };

      reader.readAsText(file)
    },
    handleFileUploadPublicKey(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        this.form.publicKey = e.target.result
        this.publicKeyText = e.target.result
      };

      reader.readAsText(file)
    },
    updateSSH(){
      let that = this
      if (that.form.name != '' || that.form.id != '') {
        let form = {
          idSSH: this.form.id,
          name: this.form.name,
          password: this.form.password,
          idPod: this.form.pod,
        }
        if (this.form.statePrivateKey == 1){
          form.privateKey = this.privateKeyText
        }

        if (this.form.statePublicKey == 1){
          form.publicKey = this.publicKeyText
        }

        this.$engine.firstOn().security.ssh.edit(form)
        .then(resp => {
          that.$f7.alert(that.$i18n.t('common.security.update_ssh'), 'Update ssh')

          loadPage(that, {url: '/security/ssh/0'})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.security.add_ssh_error'))
        })
      }
    },
    formHasError() {
      // let that = this
      // let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      // if (this.login === undefined || this.login === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_login'))
      //   return true
      // }
      // if (this.name === undefined || this.name === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_name'))
      //   return true
      // }
      // if (this.password === undefined || this.password === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_password'))
      //   return true
      // }
      // if (this.password && !regexPassword.test(this.password)) {
      //   this.okMessageBox(this.$t('profilesPage.password_wrong_format'))
      //   return true
      // }
      // if (!this.realProfileList.filter(status => status.state === 1
      //     && ((that.hrtpNorm && status.label.includes('_HRTP'))
      //         || (that.srtpNorm && status.label.includes('_SRTP'))
      //         || (!status.label.includes('_HRTP') && !status.label.includes('_SRTP')))).length) {
      //   this.okMessageBox(this.$t('usercompany.missing_profile'))
      //   return true
      // }
      // return false
    },
    checkFormSSH() {
      if(this.form.pod == ''){
        this.canSaveSSH = false
      }
      else if(this.form.name == ''){
        this.canSaveSSH = false
      }
      /* else if(this.form.password == ''){
        this.canSaveSSH = false
      } */
      else if(this.form.statePrivateKey == 1 && this.privateKeyText == '' ){
        this.canSaveSSH = false
      }
      else if(this.form.statePublicKey == 1 && this.publicKeyText == '' ){
        this.canSaveSSH = false
      }
      else{
        this.canSaveSSH = true
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>